import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {IntermediatePart} from "../../parts/intermediatePart";
import {LayoutAbbreviation} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Shower} from "../../parts/shower";

export default class PonyWallCap extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'pony_wall_cap';
    this.isPonyWallPart = true;
    this.visible = true;
    this.partName = 'Pony Wall Cap';
    this.translateId = "visualizer.bathroom.shower.pony_wall_cap";
    this.isStoneFeature = true;
    this.disableOnHomeSections = true;
    this.shadowName = "Pony Wall Cap";
    this.layerPriority = 11;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new PonyWallCap());
  }

  disabledClick() {

  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.PonyWallCap;
    const zIndex2 = zIndexes.Shower.Custom60in.PonyWallCapShadow;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.shadowFeature) {
      this.shadowFeature.layer.zIndex = zIndex2;
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const showerParent = this.getParent().getActiveShowerGroup();
    if (showerParent.showerDimensions() !== "Pony") {
      super.hideLayers();
      return;
    }

    const conditions = this.getArrayOfConditions();
    if (!this.shadowFeature || (this.shadowFeature && !this.shadowFeature.matchesMetaForArrayOfConditions(conditions))) {
      this.setShadowFeature();
    }

    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    const matchesByBindings = this.activeFeature && this.activeFeature.dbFeature && this.activeFeature.s3Bindings && this.activeFeature.dbFeature.s3Bindings.some(binding => {
      return binding.layout === LayoutAbbreviation.All || binding.layout === layoutAbr
    });
    if (matchesByBindings && (this.activeFeature.matchesMetaForArrayOfConditions(conditions)
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const parent = this.getParent();
    const layout = parent.layout;
    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    if (layoutAbr === LayoutAbbreviation.Small){
      const activeShower = parent.showerTubComboIsActive()
        ? layout.parts[ShowerTubCombo.id]
        : layout.parts[Shower.id];
      const showerSize = activeShower.showerSize(); // 60in, 30in, ..
      // const showerDimensions = activeShower.showerDimensions(); // 15x4, Pony, ...
      return [{
        propName: 'Shower',
        propValue: 'Custom'
      }, {
        propName: 'Size',
        propValue: showerSize
      }];
    }

    return []
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures, '', '', true)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName
          && feature.dbFeature.displayName.includesCI("Pony Wall Cap - Model[For=Shower=(Custom)=Size=(30in_60in)]");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI(" - Placeholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
      this.setShadowFeature();
    }
  }

}
